// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { EventEmitter } from 'events';
import { DataCache } from '../../DataCache';
export class ExternalLinksObserver {
    constructor() {
        this._eventEmitter = new EventEmitter();
    }
    // subscribe
    subscribeToAdd(callback) {
        this._eventEmitter.on('add', callback);
    }
    subscribeToUpdate(callback) {
        this._eventEmitter.on('update', callback);
    }
    subscribeToRemove(callback) {
        this._eventEmitter.on('remove', callback);
    }
    subscribeToYtUpdate(callback) {
        this._eventEmitter.on('updateYt', callback);
    }
    // unsubscribe
    unsubscribeToAdd(callback) {
        this._eventEmitter.off('add', callback);
    }
    unsubscribeToUpdate(callback) {
        this._eventEmitter.off('update', callback);
    }
    unsubscribeToRemove(callback) {
        this._eventEmitter.off('remove', callback);
    }
    unsubscribeToYtUpdate(callback) {
        this._eventEmitter.off('updateYt', callback);
    }
    run() {
        this.subscribe();
    }
    stop() {
        this.unsubscribe();
    }
    subscribe() {
        DataCache.ExternalLinksCache.onAdd.Subscribe(this.addExternalLinkEvent, this);
        DataCache.ExternalLinksCache.onUpdate.Subscribe(this.updateExternalLinkEvent, this);
        DataCache.ExternalLinksCache.onRemove.Subscribe(this.removeExternalLinkEvent, this);
        DataCache.ExternalLinksCache.onYtDataUpdate.Subscribe(this.updateExternalYtLink, this);
    }
    unsubscribe() {
        DataCache.ExternalLinksCache.onAdd.UnSubscribe(this.addExternalLinkEvent, this);
        DataCache.ExternalLinksCache.onUpdate.UnSubscribe(this.updateExternalLinkEvent, this);
        DataCache.ExternalLinksCache.onRemove.UnSubscribe(this.removeExternalLinkEvent, this);
        DataCache.ExternalLinksCache.onYtDataUpdate.UnSubscribe(this.updateExternalYtLinkEvent, this);
    }
    addExternalLink(link) {
        this._eventEmitter.emit('add', link);
    }
    updateExternalLink(link) {
        this._eventEmitter.emit('update', link);
    }
    removeExternalLink(link) {
        this._eventEmitter.emit('remove', link);
    }
    updateExternalYtLink(link) {
        this._eventEmitter.emit('updateYt', link);
    }
    addExternalLinkEvent(link) {
        this.addExternalLink(link);
    }
    updateExternalLinkEvent(link) {
        this.updateExternalLink(link);
    }
    removeExternalLinkEvent(link) {
        this.removeExternalLink(link);
    }
    updateExternalYtLinkEvent(link) {
        this.updateExternalYtLink(link);
    }
}
